<template>
	<g>
		<rect class="backRect" :x="x + depthOffset.x" :y="y - depthOffset.y" :width="width" :height="height" />
		<polygon class="topPolygon" :points="topPolygon" />
		<polygon class="rightPolygon" :points="rightPolygon" />
		<line class="topLine" v-for="line in topLines" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" />
		<polygon class="topEdge" :points="topEdgeBack" />
		<polygon class="topEdge" :points="topEdgeFront" />
		<rect class="frontRect" :x="x" :y="y" :width="width" :height="height" />
		<rect class="bottomEdge" :x="x" :y="y + 2" :width="width" :height="0.3" />
		<rect class="deepRect" :x="x" :y="y + 2.3" :width="width" :height="6.3" />
		<rect class="topEdge" :x="x" :y="y + 8" :width="width" :height="1" />
		<polygon class="deepPolygon" :points="deepPolygon" />
	</g>
</template>

<script>
	export default {
		name: 'Shelf',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 11,
			},
			parts: {
				type: Number,
				default: 6,
			},
			rackOffset: Object,
			depthOffset: Object,
		},
		computed: {
			topPolygon() {
				return `${this.x},${this.y}
						${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}`;
			},
			rightPolygon() {
				return `${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y + 2.3}
						${this.x + this.width},${this.y + 2.3}`;
			},
			deepPolygon() {
				return `${this.x},${this.y + 2.3}
						${this.x + 1},${this.y + 2.3}
						${this.x + 1},${this.y + 8}
						${this.x},${this.y + 9}`;
			},
			topEdgeBack() {
				return `${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.width + this.depthOffset.x - this.rackOffset.x / 2},${this.y - this.depthOffset.y + this.rackOffset.y / 2}
						${this.x + this.depthOffset.x - this.rackOffset.x / 2},${this.y - this.depthOffset.y + this.rackOffset.y / 2}`;
			},
			topEdgeFront() {
				return `${this.x},${this.y}
						${this.x + this.width},${this.y}
						${this.x + this.width + this.rackOffset.x / 2},${this.y - this.rackOffset.y / 2}
						${this.x + this.rackOffset.x / 2},${this.y - this.rackOffset.y / 2}`;
			},
			topLines() {
				const lines = [];
				const partWidth = this.width / this.parts;

				for (let i = 1; i < this.parts; i++) {
					lines.push({
						x1: this.x + partWidth * i,
						y1: this.y,
						x2: this.x + this.depthOffset.x + partWidth * i,
						y2: this.y - this.depthOffset.y,
					});
				}

				return lines;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #DCDDDE;
	}
	.rightPolygon {
		fill: #C4C6C8;
	}
	.frontRect {
		fill:#DCDDDE;
	}
	.backRect {
		fill:#9FA1A4;
	}
	.topEdge {
		fill: #EFEFF0;
	}
	.topLine {
		stroke: #BABCBE;
		stroke-width: 0.4;
	}
	.bottomEdge {
		fill: #AFB1B4;
	}
	.deepRect {
		fill: #D6D6D6;
	}
	.deepPolygon {
		fill: #B8B8B8;
	}
</style>